import { render, staticRenderFns } from "./BarTooltip.vue?vue&type=template&id=65f74bd6&"
import script from "./BarTooltip.vue?vue&type=script&lang=js&"
export * from "./BarTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports